import React, { useEffect, useState } from "react";
import { useFormik } from "formik";
import * as yup from "yup";
import Button from "@material-ui/core/Button";
import Checkbox from "@material-ui/core/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import TextField from "@material-ui/core/TextField";
import IconButton from "@material-ui/core/IconButton";
import InputAdornment from "@material-ui/core/InputAdornment";
import LockOutlined from "@material-ui/icons/LockOutlined";
import PersonOutline from "@material-ui/icons/PersonOutline";
import Visibility from "@material-ui/icons/Visibility";
import VisibilityOff from "@material-ui/icons/VisibilityOff";
import AuthApi from "../../../Services/Authapi";
import swal from "sweetalert";
import ls from "local-storage";
import { Link } from "react-router-dom";

const validationSchema = yup.object({
  email: yup
    .string("Enter your email")
    .email("Enter a valid email")
    .required("Email is required"),
  password: yup.string("Enter your password").required("Password is required"),
});

const LoginForm = (props) => {
  const [showPassword, setShowPassword] = useState(false);
  const [remember, setRemember] = useState(true);

  const formik = useFormik({
    initialValues: {
      email: "",
      password: "",
    },
    validationSchema: validationSchema,
    onSubmit: async (values) => {
      let checkLogin = await AuthApi.login(values);
  
      if (checkLogin && checkLogin.access_token) {
        ls.set("authToken", checkLogin.access_token);
        ls.set("roles", checkLogin.user.roles[0].name);
        ls.set("user", checkLogin.user);
        ls.set("isActive", false);
        props.setAutUser({
          authUser: checkLogin.data,
          authToken: checkLogin.access_token,
          roles: checkLogin.user.roles[0].name,
          user: checkLogin.user,
        });
        // Apply theme immediately before reload
        const userTheme = checkLogin.user?.theme || 'light';
        if (typeof window !== 'undefined') {
          window.localStorage.setItem('theme', userTheme);
          const isDark = userTheme === 'dark';
          if (typeof document !== 'undefined') {
            document.body.classList.toggle('dark-theme', isDark);
            document.documentElement.setAttribute('data-theme', userTheme);
            document.documentElement.style.setProperty('color-scheme', userTheme);
          }
        }
        // Reload the page to apply all components with the correct theme
        window.location.reload();
      } else {
        swal("Error", checkLogin || "Login failed", "error");
      }
    },
  });

  
  useEffect(() => {
    if (props.authToken === false) {
      props.history.push("/login");
    }
  }, [props.authToken, props.history]);

  return (
    <div className="hrms-login-form-wrap">
      <form className="hrms-login-form" onSubmit={formik.handleSubmit}>
        <TextField
          fullWidth
          id="email"
          name="email"
          placeholder="Username"
          variant="outlined"
          value={formik.values.email}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          error={formik.touched.email && Boolean(formik.errors.email)}
          helperText={formik.touched.email && formik.errors.email}
          className="hrms-login-form__field"
          autoComplete="email"
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <PersonOutline />
              </InputAdornment>
            ),
          }}
        />

        <TextField
          fullWidth
          id="password"
          name="password"
          variant="outlined"
          placeholder="Password"
          type={showPassword ? "text" : "password"}
          value={formik.values.password}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          error={formik.touched.password && Boolean(formik.errors.password)}
          helperText={formik.touched.password && formik.errors.password}
          className="hrms-login-form__field"
          autoComplete="current-password"
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <LockOutlined />
              </InputAdornment>
            ),
            endAdornment: (
              <InputAdornment position="end">
                <IconButton
                  aria-label="toggle password visibility"
                  className="hrms-login-form__visibility"
                  onClick={() => setShowPassword(!showPassword)}
                  edge="end"
                >
                  {showPassword ? <VisibilityOff /> : <Visibility />}
                </IconButton>
              </InputAdornment>
            ),
          }}
        />

        <div className="hrms-login-form__meta">
          <FormControlLabel
            className="hrms-login-form__remember"
            control={
              <Checkbox
                checked={remember}
                onChange={(event) => setRemember(event.target.checked)}
                color="primary"
              />
            }
            label="Remember"
          />
          <Link className="hrms-login-form__forgot" to="/forgotpassword">
            Forgot password?
          </Link>
        </div>

        <Button
          className="hrms-login-form__submit"
          color="primary"
          variant="contained"
          type="submit"
        >
          LOGIN
        </Button>
      </form>
    </div>
  );
};

export default LoginForm;
